import { API_ENDPOINTS } from "./apiCall";
const BASE = `${API_ENDPOINTS.API_COMMAN_URL}Warehouse/`;

export const Warehouse_API_ENDPOINTS = {
  // =========================================================
  // Warehouse Master
  // =========================================================
  warehouse: {
    list: `${BASE}warehouse-list`,
    create: `${BASE}create-warehouse`,
    update: `${BASE}update-warehouse`,
    delete: `${BASE}remove-warehouse`,
    getById: `${BASE}warehouse-by-id`,
    getListByStatus: `${BASE}warehouse-by-status`,
  },

  // =========================================================
  // Warehouse Storage Location
  // =========================================================
  storageLocation: {
    generate: `${BASE}generate-warehouse-storage-location`,
    update: `${BASE}update-warehouse-storage-location`,
    list: `${BASE}warehouse-storage-location-list`,
    delete: `${BASE}delete-warehouse-storage-location`,
    getById: `${BASE}warehouse-storage-location-list-by-id`,
    validate_and_delete: `${BASE}check-warehouse-bin-usage`,
  },

  // =========================================================
  // Bin Type Master
  // =========================================================
  binType: {
    list: `${BASE}warehouse-bin-type-list`,
    create: `${BASE}create-warehouse-bin-type`,
    update: `${BASE}update-warehouse-bin-type`,
    delete: `${BASE}remove-warehouse-bin-type`,
    getListByStatus: `${BASE}warehouse-bin-type-list-by-status`,
  },

  // =========================================================
  // Warehouse Type Master
  // =========================================================
  warehouseType: {
    list: `${BASE}warehouse-type-list`,
    getById: `${BASE}warehouse-type-list-by-id`,
    create: `${BASE}create-warehouse-type`,
    update: `${BASE}update-warehouse-type`,
    delete: `${BASE}remove-warehouse-type`,
    getListByStatus: `${BASE}warehouse-type-list-by-status`,
  },

  // =========================================================
  // Warehouse Environment Type Master
  // =========================================================
  environmentType: {
    list: `${BASE}warehouse-environment-type-list`,
    getById: `${BASE}warehouse-environment-type-list-by-id`,
    create: `${BASE}create-environment-warehouse-type`,
    update: `${BASE}update-environment-warehouse-type`,
    delete: `${BASE}remove-warehouse-environment-type`,
    getListByStatus: `${BASE}warehouse-environment-type-list-by-status`,
  },

  // =========================================================
  // Location Type Master
  // =========================================================
  locationType: {
    list: `${BASE}warehouse-location-type-list`,
    getById: `${BASE}warehouse-location-type-list-by-id`,
    create: `${BASE}create-location-warehouse-type`,
    update: `${BASE}update-location-warehouse-type`,
    delete: `${BASE}remove-location-warehouse-type`,
    getListByStatus: `${BASE}warehouse-location-type-list-by-status`,
  },

  // =========================================================
  // Warehouse Mapping Master
  // =========================================================

  warehousemapping: {
    zonepackagelist: `${BASE}get-warehouse-zone-package-list`,
    warehouselist: `${BASE}warehouse-list`,
    bintypelist: `${BASE}get-warehouse-bin-type-list-by-warehouse-id`,
    list: `${BASE}warehouse-mapping-list`,
    getById: `${BASE}get-warehouse-bin-type-list-by-warehouse-id`,
    create: `${BASE}insert-warehouse-mapping-detail`,
    update: `${BASE}update-warehouse-mapping-detail`,
    delete: `${BASE}delete-warehouse-mapping-detail`,
  },

  //Master-Warehouse Type
  MASTER_GET_WAREHOUSE_TYPE_LIST: `${BASE}warehouse-type-list`,
  MASTER_GET_WAREHOUSE_TYPE_LIST_BY_ID: `${BASE}warehouse-type-list-by-id`,
  MASTER_CREATE_WAREHOUSE_TYPE: `${BASE}create-warehouse-type`,
  MASTER_UPDATE_WAREHOUSE_TYPE: `${BASE}update-warehouse-type`,
  MASTER_DELETE_WAREHOUSE_TYPE: `${BASE}remove-warehouse-type`,
  //
  //Master-Warehouse Environment

  MASTER_GET_WAREHOUSE_ENVIRONMENT_LIST: `${BASE}warehouse-environment-type-list`,
  MASTER_GET_WAREHOUSE_ENVIRONMENT_LIST_BY_ID: `${BASE}warehouse-environment-type-list-by-id`,
  MASTER_CREATE_WAREHOUSE_ENVIRONMENT: `${BASE}create-environment-warehouse-type`,
  MASTER_UPDATE_WAREHOUSE_ENVIRONMENT: `${BASE}update-environment-warehouse-type`,
  MASTER_DELETE_WAREHOUSE_ENVIRONMENT: `${BASE}remove-warehouse-environment-type`,


  // Master-Location Type
  MASTER_GET_WH_LOCATION_TYPE_LIST: `${BASE}warehouse-location-type-list`,
  MASTER_GET_WH_LOCATION_TYPE_LIST_BY_ID: `${BASE}warehouse-location-type-list-by-id`,
  MASTER_CREATE_LOCATION_TYPE: `${BASE}create-location-warehouse-type`,
  MASTER_UPDATE_LOCATION_TYPE: `${BASE}update-location-warehouse-type`,
  MASTER_DELETE_LOCATION_TYPE: `${BASE}remove-location-environment-type`,

  MASTER_DELETE_LOCATION_TYPE: `${BASE}remove-location-warehouse-type`,

  //Master-Warehouse Object Type

  MASTER_GET_WAREHOUSE_OBJECT_TYPE_LIST: `${BASE}warehouse-object-type-list`,
  MASTER_GET_WAREHOUSE_OBJECT_TYPE_LIST_BY_ID: `${BASE}warehouse-object-type-list-by-id`,
  MASTER_CREATE_OBJECT_TYPE: `${BASE}create-warehouse-object-type`,
  MASTER_UPDATE_OBJECT_TYPE: `${BASE}update-warehouse-object-type`,
  MASTER_DELETE_OBJECT_TYPE: `${BASE}remove-warehouse-object-type`,



  // =========================================================
  // Object Type Master
  // =========================================================

  objectType: {
    list: `${BASE}warehouse-object-type-list`,
    getById: `${BASE}warehouse-object-type-list-by-id`,
    create: `${BASE}create-warehouse-object-type`,
    update: `${BASE}update-warehouse-object-type`,
    delete: `${BASE}remove-warehouse-object-type`,
    getListByStatus: `${BASE}warehouse-object-type-list-by-status`,
  },

  fgWarehouse: {
    location_list: `${BASE}get-warehouse-location-by-region-and-package`,
    location_list_fg_reverse: `${BASE}get-warehouse-location-by-so-region-and-package`,
    location_bin_usage: `${BASE}warehouse-storage-location-list-with-vertical-detail-by-id`,
    so_wise_location_list:`${BASE}get-so_number-wise-warehouse-location-list`,
  },

  warehouseReport: {
    master_report: `${BASE}get-warehouse-data-report`,
    refresh_report: `${BASE}get-production-data-report-refresh`,
    filter_production_date_range_report: `${BASE}get-production-data-report-by-date-range`,
  },

  warehouseDashboard: {
    stock_summary: `${BASE}get-warehouse-stock-summary`,
    inward_shipment: `${BASE}get-warehouse-inward-shipment-today`,
    outward_shipment: `${BASE}get-warehouse-outward-shipment-today`,
    inward_outward_shipment:`${BASE}get-warehouse-inward-and-outward-shipment`,
  }

};

